var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "public-width"
  }, [_vm._m(0), _c('div', {
    staticClass: "login-page-main clearfix"
  }, [_vm._m(1), _c('div', {
    staticClass: "login-right"
  }, [_c('div', {
    staticClass: "login-box-shadow"
  }), _c('div', {
    staticClass: "login-box-main"
  }, [_c('div', {
    staticClass: "login-box-title"
  }, [_vm._v("登录微脉输入法账号")]), _c('div', {
    staticClass: "login-box-type"
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.changeLoginMode(0);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.loginIndex === 0 ? require('../assets/images/login-03-active.png') : require('../assets/images/login-03.png')
    }
  }), _vm._v("扫码登录 ")]), _c('div', {
    staticStyle: {
      "color": "#bdbdbd"
    }
  }, [_vm._v("|")]), _c('div', {
    on: {
      "click": function ($event) {
        return _vm.changeLoginMode(1);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.loginIndex === 1 ? require('../assets/images/login-04-active.png') : require('../assets/images/login-04.png')
    }
  }), _vm._v("手机号登录 ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isPhoneLogin,
      expression: "!isPhoneLogin"
    }],
    staticClass: "login-erweima"
  }, [_c('div', {
    staticClass: "login-ewm-title"
  }, [_vm._v("使用微脉输入法APP扫码登录")]), _vm._m(2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPhoneLogin,
      expression: "isPhoneLogin"
    }],
    staticClass: "login-phonenum"
  }, [_c('div', {
    staticClass: "login-pn-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phoneNumber,
      expression: "phoneNumber"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": _vm.phoneNumber
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.phoneNumber = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "login-pn-desc clearfix"
  }, [_c('div', [_vm._v("验证码")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phoneYanzhengma,
      expression: "phoneYanzhengma"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": _vm.phoneYanzhengma
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.phoneYanzhengma = $event.target.value;
      }
    }
  })]), _c('div', {
    class: {
      huise: !_vm.yzmFlag
    },
    on: {
      "click": _vm.sendPhoneCode
    }
  }, [_vm._v(" " + _vm._s(_vm.countNum) + " ")])]), _c('div', {
    staticClass: "login-pn-code",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(" " + _vm._s(_vm.loginWord) + " ")])])])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "logo-content clearfix"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20250911144220.png",
      "alt": ""
    }
  })]), _c('strong', [_vm._v("微脉输入法 话术管理后台")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-left"
  }, [_c('div', {
    staticClass: "login-l-01"
  }, [_c('img', {
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20250822171136.png",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "login-l-02"
  }, [_c('img', {
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20250822171237.png",
      "alt": ""
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-ewm-code"
  }, [_c('img', {
    attrs: {
      "src": "",
      "id": "qrcode"
    }
  })]);
}];
export { render, staticRenderFns };